import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import { userAccountListByIp, banOpenidLogin } from "@/api/role";
export default {
  name: "BanAccountByIp",
  props: {
    Ip: String,
    sdate: String,
    edate: String
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return userAccountListByIp({
              ip: _this.Ip,
              sdate: _this.sdate,
              edate: _this.edate
            });
          case 2:
            res = _context.sent;
            if (res.code == 0) {
              _this.tableData = res.data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      serverList: {},
      hour: 60 * 60,
      day: 24 * 60 * 60,
      year: 365 * 24 * 60 * 60,
      formData: {
        server_id: this.serverId,
        role_list: [],
        time: 86400,
        ban_reason: ""
      },
      tableData: []
    };
  },
  watch: {},
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.formData.role_list = val.map(function (item) {
        return item.openId;
      });
    },
    banRole: function banRole() {
      var _this2 = this;
      if (this.formData.role_list.length == 0) {
        this.$message({
          message: "请选择角色"
        });
        return;
      }
      // 检查输入时间是否有效，是否有超出范围
      var time = Math.round(this.formData.time);
      if (isNaN(time) || time <= 0) {
        this.$message({
          type: "error",
          message: "封禁时间必须为正数"
        });
        return;
      }
      if (time > 50 * this.year) {
        this.$message({
          type: "error",
          message: "封禁时间不能超过50年"
        });
        return;
      }
      banOpenidLogin(this.formData).then(function (res) {
        if (res.code == 0) {
          _this2.$message.success("成功");
          _this2.$emit("banFinish");
        }
      });
    },
    setTime: function setTime(seconds) {
      this.formData.time = String(seconds);
    },
    setBanReason: function setBanReason(data) {
      this.formData.ban_reason = data;
    }
  }
};